<template>
  <div v-if="membre">
    <div class="columns is-gapless has-background-white is-marginless">
      <div
        class="column is-narrow is-flex is-padding-small"
        :class="membre.status === 'initiated' || membre.status === 'declined' ? 'has-background-white--darken1 is-border-right tooltip is-tooltip-right' : 'has-background-success'"
        :data-tooltip="membre.status === 'pending' ? 'En attente de signature' : ''">
        <span
          class="icon is-self-centered"
          :class="membre.status === 'initiated' || membre.status === 'declined' ? 'has-text-danger' : 'has-text-white'">
          <i
            v-if="membre.status === 'initiated'"
            class="fas fa-clock"></i>
          <i
            v-else-if="membre.status === 'declined'"
            class="fas fa-exclamation-circle"></i>
          <i
            v-else
            class="fas fa-check-circle"></i>
        </span>
      </div>
      <div class="column columns is-gapless is-padding-small is-multiline">
        <div class="column is-6 is-4-widescreen is-3-fullhd is-padding-xxsmall">
          <r-label
            v-if="membre.is_buyer"
            :label="'RÉSERVATAIRE / Acquéreur'"
            :is-required="false"></r-label>
          <r-label
            v-else
            :label="'RÉSERVATAIRE / CO-Acquéreur'"
            :is-required="false"></r-label>
          <div
            v-if="membre"
            class="title is-5 has-text-weight-medium">
            <div
              v-if="membre.nature === 'corporation'"
              class="is-uppercase">
              {{ membre.corporation_name }}
            </div>
            <div v-if="membre.first_name && membre.last_name">
              <span class="is-uppercase">{{ membre.last_name }} </span><span style="text-transform: capitalize">{{ membre.first_name }}</span>
            </div>
          </div>
        </div>
        <div class="column is-12 is-4-widescreen is-6-fullhd columns is-gapless is-multiline">
          <div class="column is-6 is-12-widescreen is-6-fullhd is-padding-xxsmall">
            <r-label
              :label="'Téléphone'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-normal">
              <phone-number :phone="membre.phone"></phone-number>
            </div>
          </div>
          <div class="column is-6 is-12-widescreen is-6-fullhd is-padding-xxsmall">
            <r-label
              :label="'MAIL'"
              :is-required="false"></r-label>
            <div class="title is-5 has-text-weight-normal">
              <span>{{ membre.email }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="membre.status !== 'declined' && procedure.status !== 'deleted'"
      class="columns is-gapless is-multiline has-background-white is-border-top">
      <div
        class=" column columns is-gapless is-centered is-padding-top is-padding-bottom"
        :class="[!((isAdmin && isPromoteur) && canUseLre) ? 'is-12' : 'is-12 is-6-widescreen is-border-right']">
        <div
          class="column is-narrow has-vadBadge--topright has-vadBadge--out-quarter is-size-5 is-size-6-widescreen is-size-4-fullhd">
          <i
            v-if="membre.status === 'notified' || membre.status === 'declined'"
            class="fal fa-5x fa-file-alt"></i>
          <i
            v-else-if="membre.status === 'signed'"
            class="fal fa-5x fa-file-contract"></i>
          <span
            v-if="membre.status === 'notified'"
            class="vadBadge is-large is-bordered is-danger tooltip is-tooltip-top"
            data-tooltip="En attente de signature">
            <span class="icon"><i class="fas fa-clock"></i></span>
          </span>
          <span
            v-else-if="membre.status === 'signed'"
            class="vadBadge is-large is-bordered is-success tooltip is-tooltip-top"
            data-tooltip="Contrat signé">
            <span class="icon"><i class="fas fa-check"></i></span>
          </span>
          <span
            v-else-if="membre.status === 'declined'"
            class="vadBadge is-large is-bordered is-danger tooltip is-tooltip-top"
            data-tooltip="Contrat refusé">
            <span class="icon"><i class="fas fa-exclamation"></i></span>
          </span>
        </div>
        <div class="column is-narrow is-margin-left-large is-padding-top-xxsmall">
          <div class="title is-3 is-marginless  has-text-weight-medium">
            Contrat de réservation
          </div>
          <div class="is-padding-bottom-xsmall">
            <span
              v-if="membre.status === 'done' || membre.status === 'signed'"
              class="is-size-7 has-text-success is-uppercase">Signé le {{ membre.updated_on | date }} à {{ membre.updated_on | dtFormat('HH[H]mm') }}</span>
            <span
              v-else-if="membre.status === 'declined'"
              class="is-size-7 has-text-danger is-uppercase">Signature refusée le {{ membre.updated_on | date }}à {{ membre.updated_on | dtFormat('HH[H]mm') }}</span>
            <span
              v-else-if="membre.status === 'notified' && procedure.status !== 'deleted' && procedure.status !== 'expired'"
              class="is-size-7 has-text-danger is-uppercase">En attente de signature</span>
            <div
              class="has-text-weight-semibold is-italic is-size-7">
              ID signature: {{ membre.file_id }}
            </div>
          </div>
          <div class="is-margin-top-xxsmall">
            <button
              v-if="procedure.status === 'deleted' || procedure.status === 'expired' || procedure.status === 'rejected' || !canSign"
              :disabled="true"
              class="button is-small is-success is-transform-none is-fullwidth is-radius">
              <span class="is-uppercase">Signer en face à face</span>
            </button>
            <button
              v-else-if="membre.status === 'signed'"
              @click="openPreviewContratMembre()"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </button>
            <button
              v-else-if="procedure.status === 'done'"
              @click="openPreviewContrat()"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </button>
            <div v-else>
              <button
                @click="openPreview()"
                class="button is-small is-success is-transform-none is-fullwidth is-radius">
                <span class="is-uppercase">Signer en face à face</span>
              </button>
              <button
                @click="sendYousignContractByMail(membre)"
                style="margin-top: 10px"
                class="button is-small is-success is-transform-none is-fullwidth is-radius">
                <span class="is-uppercase">Envoyer contrat par email</span>
              </button>
              <div
                v-if="membre.last_send_mail"
                class="has-text-weight-semibold is-italic is-size-7">
                <span>Date du dernier envoi: le {{ membre.last_send_mail | date }} à {{ membre.last_send_mail | dtFormat('HH[H]mm') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="column is-12 is-6-widescreen is-border-left columns is-gapless is-centered is-padding-top is-padding-bottom"
        v-if="(isAdmin && isPromoteur) && canUseLre">
        <div
          class="column is-narrow has-vadBadge--topright has-vadBadge--out-quarter is-size-5 is-size-6-widescreen is-size-4-fullhd">
          <i class="fal fa-5x fa-mail-bulk"></i>
          <span
            v-if="(membre.status === 'notified' && procedure.status !== 'deleted' && procedure.status !== 'expired') || !EveryBodySign"
            class="vadBadge is-large is-bordered tooltip is-tooltip-top is-danger"
            data-tooltip="DISPONIBLE À LA FIN DE LA PROCÉDURE">
            <span class="icon">
              <i class="fas fa-clock"></i>
            </span>
          </span>
          <span
            v-else-if="!buyerLre"
            class="vadBadge is-large is-bordered tooltip is-tooltip-top is-danger"
            data-tooltip="RECOMMANDÉ EN ATTENTE">
            <span class="icon">
              <i class="fas fa-clock"></i>
            </span>
          </span>
          <span
            v-else-if="isWainting"
            class="vadBadge is-large is-bordered tooltip is-tooltip-top is-danger"
            data-tooltip="En attente de réception">
            <span class="icon">
              <i class="fas fa-clock"></i>
            </span>
          </span>
          <span
            v-else-if="isEv || isRecipientUpdate"
            class="vadBadge is-large is-bordered tooltip is-tooltip-top is-success"
            data-tooltip="Envoyé">
            <span class="icon">
              <i class="fas fa-check"></i>
            </span>
          </span>
          <span
            v-else-if="isDp"
            class="vadBadge is-large is-bordered tooltip is-tooltip-top is-success"
            data-tooltip="Livré">
            <span class="icon">
              <i class="fas fa-check"></i>
            </span>
          </span>
          <span
            v-else-if="isAr"
            class="vadBadge is-large is-bordered tooltip is-tooltip-top is-success"
            data-tooltip="Recu">
            <span class="icon">
              <i class="fas fa-check"></i>
            </span>
          </span>
          <span
            v-else-if="isBounced"
            class="vadBadge is-large is-bordered tooltip is-tooltip-top is-danger"
            data-tooltip="Erreur">
            <span class="icon">
              <i class="fas fa-exclamation"></i>
            </span>
          </span>
          <span
            v-else-if="isNegligence"
            class="vadBadge is-large is-bordered tooltip is-tooltip-top is-danger"
            data-tooltip="Négligence">
            <span class="icon">
              <i class="fas fa-exclamation"></i>
            </span>
          </span>
        </div>
        <div
          class="column is-narrow is-margin-left-large is-padding-top-xxsmall"
          :class="{'has-content-disabled' : !canUseLre}">
          <div class="title is-3 is-marginless  has-text-weight-medium">
            Recommandé electronique
          </div>
          <div class="is-padding-bottom-xsmall">
            <span
              v-if="(membre.status === 'notified' && procedure.status !== 'deleted' && procedure.status !== 'expired') || !EveryBodySign"
              class="is-size-7 is-uppercase has-text-danger">Disponible à la fin de la procédure</span>
            <span
              v-else-if="!buyerLre"
              class="is-size-7 is-uppercase has-text-danger">Recommandé en attente</span>
            <span
              v-else-if="buyerLre && isWainting"
              class="is-size-7 is-uppercase has-text-danger">En attente de réception</span>
            <span
              v-else-if="buyerLre && (isEv || isDp || isRecipientUpdate)"
              class="is-size-7 has-text-success is-uppercase">ENVOYÉ le {{ buyerLre.updated_on | date }}</span>
            <span
              v-else-if="isAr"
              class="is-size-7 has-text-success is-uppercase">Recu le {{ buyerLre.updated_on | date }}</span>
            <span
              v-else-if="isBounced"
              class="is-size-7 has-text-danger is-uppercase">Erreur</span>
            <span
              v-else-if="isNegligence"
              class="is-size-7 has-text-danger is-uppercase">
              Négligence
            </span>
            <div
              v-if="isBuyerLreId"
              class="has-text-weight-semibold is-italic is-size-7">
              ID LRE: {{ buyerLre.lre_id }}
            </div>
          </div>
          <div class="is-margin-top-xxsmall">
            <button
              v-if="loadLre"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <i class="fas fa-spinner fa-spin"></i>
            </button>
            <button
              v-else-if="buyerLre && (isEv || isDp || isWainting || isAr || isBounced || isRecipientUpdate || isNegligence)"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius"
              @click="openModalLre()">
              <span class="is-underline">Suivre procédure</span>
            </button>
            <button
              v-else-if="(membre.status === 'initiated' && procedure.status !== 'deleted' && procedure.status !== 'expired') || !EveryBodySign"
              :disabled="true"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <span class="is-uppercase">Envoyer LRE</span>
            </button>
            <button
              v-else-if="(!buyerLre || buyerLre.failed) && EveryBodySign"
              @click="openModalLre()"
              :disabled="!canUseLre"
              class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <span class="is-uppercase">Envoyer LRE</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="membre.comment"
      class="columns is-gapless is-border-top has-background-warning is-padding-small">
      <div class="column is-12 is-padding-left-large">
        <div class="is-uppercase is-size-6">
          <b>PROCÉDURE ANNULÉE : Commentaires</b>
        </div>
        <div class="is-padding-top-small is-size-7">
          {{ membre.comment }}
        </div>
        <div class="is-padding-top-small is-size-6">
          <span><b>Date :</b></span> {{ membre.updated_on | dateRefus }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { Adv } from '@/mixins'
export default {
  name: 'ContratItem',
  mixins: [Adv],
  props: {
    procedureLre: Array,
    membre: Object,
    signatures: Array,
    procedure: Object,
    idx: Number
  },
  data () {
    return {
      currentSru: 'registered',
      loadLre: false,
      panel: 'contrat',
      loadingDocuents: false,
      intervalId: null
    }
  },
  computed: {
    ...mapState(['currentAdv', 'device']),
    ...mapGetters(['isAdmin', 'isPromoteur', 'canUseLre']),
    /**
      * is lre
      * @returns {boolean}
      */
    isLre () {
      return this.buyerLre !== null
    },
    isBuyerLreId () {
      if (this.buyerLre && this.buyerLre.lre_id !== undefined) {
        return this.buyerLre.lre_id
      }
      return this.buyerLre
    },
    /**
      * every body sign
      * @returns {boolean}
      */
    EveryBodySign () {
      let contratSign = []
      this.procedure.members.forEach(x => {
        if (x.status === 'signed' || x.status === 'done') contratSign.push(x.status)
      })
      return contratSign.length === this.procedure.members.length
    },
    /**
      * config yousign url
      * @returns {string}
      */
    yousignSignatureUrl () {
      return this.$configs.YOUSIGN_URL
    },
    /**
      * can sign
      * @returns {boolean}
      */
    canSign () {
      if (this.membre.position === 0) {
        return true
      } else if (this.membre.position === 1) {
        let membre1 = this.procedure.members.find(x => x.position === 0)
        if (membre1.status === 'initiated') {
          return false
        } else {
          return true
        }
      } else if (this.membre.position === 2) {
        let membre1 = this.procedure.members.find(x => x.position === 0)
        let membre2 = this.procedure.members.find(x => x.position === 1)
        if (membre1.status === 'initiated' || membre2.status === 'initiated') {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    /**
      * current buyer
      * @returns {object}
      */
    buyer () {
      return this.membre.buyer
    },
    /**
      * current buyer lre
      * @returns {object}
      */
    buyerLre () {
      if (this.buyer) {
        const filtered = this.procedureLre.filter(x => x.details.buyer === this.buyer.pk)
        return filtered.length ? filtered[filtered.length - 1] : null
        // return this.procedureLre.find(x => {
        //   if (x.details.buyer === this.buyer.pk && x.status === 'waiting') {
        //     return x.details.buyer === this.buyer.pk
        //   } else {
        //     return null
        //   }
        // })
      } else {
        return null
      }
    },
    /**
      * buyerLre created_on
      * @returns {string}
      */
    hasSendingDate () {
      if (this.buyerLre) {
        return this.buyerLre.created_on
      } else {
        return null
      }
    },
    /**
      * buyerLre status is ev
      * @returns {boolean}
      */
    isEv () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'ev'
      } else {
        return false
      }
    },
    /**
      * buyerLre status is dp
      * @returns {boolean}
      */
    isDp () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'dp'
      } else {
        return false
      }
    },
    /**
      * buyerLre status is waiting
      * @returns {boolean}
      */
    isWainting () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'waiting'
      } else {
        return false
      }
    },
    /**
      * buyerLre status is bounced
      * @returns {boolean}
      */
    isBounced () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'bounced'
      } else {
        return false
      }
    },
    isNegligence () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'negligence'
      } else {
        return false
      }
    },
    /**
      * buyerLre status is refused
      * @returns {boolean}
      */
    isRefused () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'refused'
      } else {
        return false
      }
    },
    /**
      * buyerLre status is ar
      * @returns {boolean}
      */
    isAr () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'ar'
      } else {
        return false
      }
    },
    /**
      * buyerLre status is recipient_update
      * @returns {boolean}
      */
    isRecipientUpdate () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'recipient_update'
      } else {
        return false
      }
    },
    documentsIsReady () {
      if (this.currentAdv.signed_contract) {
        return this.currentAdv.signed_contract
      } else {
        return false
      }
    }
  },
  watch: {
    'member.last_send_mail' (newValue) {
      if (newValue) {
        clearInterval(this.intervalId)
      }
    },
    beforeDestroy () {
      clearInterval(this.intervalId)
    }
  },
  methods: {
    /**
      * open lre preview
      */
    openModalLre () {
      let requestElem = {
        adv_pk: this.currentAdv.pk
      }
      let params = {
        from: 'signature',
        currentSru: this.currentSru,
        requestElem,
        buyerPk: this.membre.buyer.pk,
        appelDeFondIndex: null,
        sruIndex: null,
        lre: this.buyerLre
      }
      this.$store.commit('setModal', { mode: 'RECOMMENDED_MANAGEMENT', params })
    },
    /**
      * open preview contrat
      */
    openPreviewContrat () {
      let params = {
        link: this.currentAdv.signed_contract
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    /**
      * open preview contrat by member
      */
    openPreviewContratMembre () {
      const apiUrl = this.$configs.APIURL
      let params = {
        link: apiUrl + '/yousign-sign-file/' + this.membre.signature_request + '/' + this.membre.file_id
      }
      window.open(params.link, '_blank')
    },
    /**
      * open preview yousign
      */
    openPreview () {
      const procedure = this.membre.signature_link
      let sandboxLink = procedure + (procedure.includes('?') ? '&' : '?') + 'disable_domain_validation=true'
      let params = {
        link: sandboxLink
      }
      if (this.device === 'desktop') {
        this.$store.commit('setModal', { mode: 'YOUSIGN_PREVIEW', params })
      } else {
        let link = document.createElement('a')
        link.href = params.link
        link.target = '_blank'
        link.rel = 'noopener noreferrer'
        link.click()
      }
    },
    startChecking () {
      let attempts = 0
      this.intervalId = setInterval(async () => {
        await this.checkLastSendMail()
        attempts++
        if (attempts >= 3) {
          clearInterval(this.intervalId)
        }
      }, 5000)
    },
    async checkLastSendMail () {
      try {
        const response = await this.$api.axios.get(`/get-signing-procedure-member/${this.membre.yousign_id}`)
        this.membre.last_send_mail = response.data.last_send_mail
      } catch (err) {
        console.error("Erreur lors de la récupération de la date d'envoi du mail", err)
      }
    }
  }
}
</script>
